import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Auction, Vehicle} from "domain-models"
import {useAuctionSettings} from "hooks/StateHooks"
import React from "react"
import AuctionPrice from "../../../../components/Auction/AuctionPrice"
import BidButtons from "../../../../components/Auction/BidButtons"
import Countdown from "../../../../components/Countdown"
import Documents from "./Documents"
import IgnoreButton from "./IgnoreButton"
import Protocol from "./Protocol"
import _ from "lodash"
import Trans from '../../../../components/Trans'

type SidebarProps = {
  close: () => void
  auction: Auction
}

type State = {
  vehicle: Vehicle
}

class Sidebar extends React.Component<SidebarProps, State> {
  constructor(props: SidebarProps) {
    super(props)

    this.state = {
      vehicle: _.first(props.auction.subjects)?.vehicle as Vehicle || _.first(props.auction.subjects)?.leading || _.first(props.auction.subjects)?.leasing
    }
  }

  render() {
    const auction = this.props.auction
    return (
      <div className='w-full h-full flex flex-col px-2 pb-2 -mt-1 border-l scrollbar scrolling-smooth scrolling-touch overflow-y-scroll justify-between'>
        <div className="flex flex-col">
          {
            auction.status === 'cancelled' && (
              <div className="mb-3 rounded bg-red-100 border-2 border-red-500 text-red-800 px-3 py-3 text-center">
                <p className="font-bold text-lg"><Trans>Auktion abgebrochen</Trans></p>
                <p className="text-sm mt-1"><Trans>Diese Auktion wurde vom Verkäufer abgebrochen.</Trans></p>
              </div>
            )
          }

          {
            !!auction.isOutbid && auction.round?.Type === 0 && auction.round?.bid && (
              <div className="mb-3 rounded bg-red-100 border-2 border-red-400 text-red-700 px-3 py-3 text-center">
                <p className="font-bold text-lg flex items-center justify-center">
                  <Icon icon='exclamation-triangle' className="mr-2" />
                  <Trans>Sie wurden überboten</Trans>
                </p>
                <p className="text-sm mt-1"><Trans>Ein anderer Bieter hat ein höheres Gebot abgegeben.</Trans></p>
              </div>
            )
          }

          <Countdown auction={auction} timeTillDate={auction.round.EndsOn} hotBid={true}/>

          <AuctionPrice auction={auction} small={true}/>

          <div className="mt-2">
            <BidButtons auction={auction}/>
          </div>

          <div className={'text-sm my-2 text-gray-500'}>
            {
              auction.round.Type === 1 ?
                <span>
                  <Icon icon='gavel'/> {auction.round.bids.length} {auction.round.bids.length === 1 ? <Trans>Gebot</Trans> : <Trans>Gebote</Trans>}
                </span>
                : null
            }
          </div>

          <div className="mb-4">
            <Documents documents={this.state.vehicle.documents}/>
          </div>

          <div className="mb-4">
            {useAuctionSettings().showProtocol && <Protocol history={auction.history}/>}
          </div>
        </div>

        <div>
          <IgnoreButton auction={auction} close={this.props.close}/>
        </div>
      </div>
    )
  }
}

export default Sidebar
